// @TODO: improve this messages
import { PLATFORMS } from '@domain/platform';

export const OPEN_ASSOCIATE_ACCOUNTS_MODAL = 'Integration succeeded, now link your accounts to start using Pareto Ads';
export const ERROR_STATE_INVALID = 'Sorry, this request is invalid. Try again later';
export const ERROR_AUTHORIZATION_CODE = 'An unexpected error. Try again';
export const ERROR_GOOGLE_NOT_ADS_USER = 'Your Google Mail is not associated to any Google Ads Account. It is not possible to read any data from Google Ads.';

const WARNING_INTEGRATION_CANCELED = "{'scopes': [ErrorDetail(string='This field is required.', code='required')], 'code': [ErrorDetail(string='This field is required.', code='required')]}";

export const MESSAGES = {
    [WARNING_INTEGRATION_CANCELED]: 'You haven\'t completed your integration. Please, retry the process.',
};

export const ASSOCIATE_ACCOUNTS_PLATFORMS = {
    GOOGLE_ADS: PLATFORMS.GOOGLE_ADS.value,
    GOOGLE_ANALYTICS: PLATFORMS.GOOGLE_ANALYTICS.value,
};
